import FeatsManagePane from './FeatsManagePane';
import FeatsManagePaneFeat from './FeatsManagePaneFeat';

export default FeatsManagePane;
export { FeatsManagePane, FeatsManagePaneFeat };
